import { css } from "@emotion/react";

export const styles = {
    dummyContainer: css({
        justifyContent: "center",
        display: "flex",
        alignItems: "center",
        backgroundColor: "#F9F9F9",
        padding: "10px",
        border: "1px solid #EEEEEE",
        fontSize: "12px",
        lineHeight: "20.4px",
        gap: "10px",
        borderRadius: "0px 0px 6px 6px"
    }),
    primaryUploadCTA: (guestUser) => css({
        display: "flex",
        alignItems: "center",
        cursor: guestUser ? "none" : "pointer",
        justifyContent: "center",
        border: "1px solid #EEEEEE",
        backgroundColor: "#F9F9F9",
        borderRadius: "8px",
        padding: "16px",
        fontSize: "14px",
        ":hover": {
            border: "1px solid #262626"
        },
        opacity: guestUser ? 0.5 : 1,
        pointerEvents: guestUser ? "none" : "auto",
    }),
    FileUploadCTA: css({
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        justifyContent: "center",
        border: "1px solid #EEEEEE",
        backgroundColor: "#F9F9F9",
        borderRadius: "8px",
        padding: "16px",
        fontSize: "14px",
        width: "100%",
    }),
    secondaryUploadCTA: {
        cursor: "pointer",
        justifyContent: "center",
        fontSize: "14px",
        ":hover": {
            border: "1px solid #262626"
        },
    },
    container: (isLoading) => css({
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        width: "100%",
        opacity: isLoading ? 0.5 : 1,
        pointerEvents: isLoading ? "none" : "auto"
    }),
    innerContainer: { 
        padding: "18px", 
        display: "flex", 
        flexDirection: "column", 
        gap: "16px",
        fontSize: "12px", 
        lineHeight: "20px", 
        fontWeight: "500", 
        color: "#262626",

    },
    dummyJobs: css`
    height: 60px;
    display: flex;
    border: 0.5px solid #EEEEEE;
    cursor: pointer;
    `,
};
